const month_long = {
    ru: ['','Января','Февраля','Марта','Апреля','Мая','Июня','Июля','Августа','Сентября','Октября','Ноября','Декабря'],
    en: ['','January','February','March','April','May','June','July','August','September','October','November','December'],
};
/*
const month_short = {
    ru: ['','Янв','Фев','Мар','Апр','Май','Июн','Июл','Авг','Сен','Окт','Ноя','Дек'],
    en: ['','Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'],
};
*/
/**
 * @param date в формате 2023-01-01T12:15:00.000Z
 * @returns string в формате 2023-01-01 12:15:00
 */
export const convert = (date?: string | null) => {
    if(!date) return '';
    if(!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z$/.test(date)) return date;
    const [ d, t ] = date.split('T');
    return  d + ' ' + t.split('.')[0];
};
/**
 * @param date в формате 2023-01-01T12:15:00.000Z
 * @param lang язык вывода
 * @returns string в формате 1 Янв 2023 12:15
 */
export const convert2human = (date?: string | null, lang?: 'ru'|'en') => {
    if(!date) return '';
    if(!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z$/.test(date)) return date;
    let month = month_long.ru;
    if(lang === 'en') month = month_long.en;
    const [ d, t ] = date.split('T');
    const [ year, mon, day ] = d.split('-');
    // eslint-disable-next-line
    const [ hour, min, sec ] = t.split(':');
    return  parseInt(day) + ' ' + month[parseInt(mon)] + ' ' + year + ' ' + hour + ':' + min;
};
/**
 * @param date в формате 2023-01-01T12:15:00.000Z
 * @param lang язык вывода
 * @returns string в формате 1 Января 2023
 */
export const date2human = (date?: string | null, lang?: 'ru'|'en') => {
    if(!date) return '';
    if(!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z$/.test(date)) return date;
    let month = month_long.ru;
    if(lang === 'en') month = month_long.en;
    const [ year, mon, day ] = date.split('T')[0].split('-');
    return  parseInt(day) + ' ' + month[parseInt(mon)] + ' ' + year;
};
/**
 * @param date в формате 2023-01-01T12:15:00.000Z
 * @returns string в формате HH:MM
 */
export const time2human = (date?: string | null) => {
    if(!date) return '';
    if(!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z$/.test(date)) return date;
    const [ hour, min ] = date?.split('T')[1].split(':');
    return `${hour}:${min}`;
};
/**
 * @param date в формате 2023-01-01T12:15:00.000Z
 * @returns arraу в формате [ YYYY, MM, DD, HH, MM, SS ]
 */
export const date2array = (date?: string | null): [ number, number, number, number, number, number ] => {
    if(!date) return [ 0, 0, 0, 0, 0, 0 ];
    if(!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z$/.test(date)) return [ 0, 0, 0, 0, 0, 0 ];
    const [ d, t ] = date.split('T');
    const [ year, mon, day ] = d.split('-');
    const [ hour, min, sec ] = t.split(':');
    return [
        parseInt(year),
        parseInt(mon),
        parseInt(day),
        parseInt(hour),
        parseInt(min),
        parseInt(sec)
    ];
};
/**
 * Возвращает массив времени встречи для экспорта через ICS
 * Время на входе всегда московское, нам необходимо перевести его в UTC.
 * Для этого мы отнимаем от него 3 часа.
 * @param date в формате 2023-01-01T12:15:00.000Z
 * @returns arraу в формате [ YYYY, MM, DD, HH, MM ]
 */
export const date2array4export = (date?: string | null): [ number, number, number, number, number ] => {
    if(!date) return [ 0, 0, 0, 0, 0 ];
    if(!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z$/.test(date)) return [ 0, 0, 0, 0, 0 ];
    const d = new Date(date);
    d.setHours(d.getHours() - 3);
    //console.log('MSK', date);
    //console.log('UTC', d.toISOString());
    const ret = date2array(d.toISOString());
    return ret.slice(0, ret.length - 1) as [ number, number, number, number, number ];
};
